const styles = {
  global: {
    html: {
      height: "100%",
    },
    body: {
      height: "100%",
    },
    "#root": {
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
  },
};

export { styles };
